import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

export const ModalFooter = () => <UIText1>Номер указан в формате 86:08:0020303:267</UIText1>;
